export default "__VITE_ASSET__BwVpVK2V__"